export default __webpack_public_path__ + "static/media/bath_icon_b.abd61b66.svg";